const FTAG_TOKEN_EXPIRY = "ftag_enable_expired_token";
const FTAG_GOOGLE_AUTO_COMPLETE = "ftag_google_autocomplete_by_store";

function isTokenExpiryEnabled(featureTags) {
    return featureTags && featureTags[FTAG_TOKEN_EXPIRY];
}

export function isGoogleAutoCompleteEnabled(featureTags) {
    return featureTags && featureTags[FTAG_GOOGLE_AUTO_COMPLETE];
}

function logoutUser(apiService, router, notification) {
    // Clear local storage
    localStorage.clear();
  
    // Update login state
    apiService.setLogin({ loggedIn: false, userDetails: null });
  
    // Preserve redirect URL if on cart page
    const queryParams = router.url.includes('cart')
      ? { queryParams: { redirectURL: router.url } }
      : {};
  
    // Navigate to sign-in page
    router.navigate(['/sign-in'], queryParams);
  
    // Show logout notification
    notification.warning('You have been logged-out. Please sign-in again!', 5000);
  }

export { isTokenExpiryEnabled, logoutUser }